import { c as _c } from "react/compiler-runtime";
import { HOTEL_DETAILS_ACTIVE_TAB } from "@website/accommodation-ui/constant/keys";
import { HotelCardInfoOptions } from "@website/accommodation-ui/hotel-card-new/hotel-card-info/hotel-card-info-options";
import { HotelCardInfoPropertiesType } from "@website/accommodation-ui/hotel-card-new/hotel-card-info/hotel-card-info.types";
import { HotelCardRating } from "@website/accommodation-ui/hotel-card-new/hotel-card-info/hotel-card-rating";
import { HotelCardLink, HotelCardLinkProperties } from "@website/accommodation-ui/hotel-card-new/hotel-card-link";
import { HotelCardStars } from "@website/accommodation-ui/hotel-card-new/hotel-card-stars";
import { HotelSnappPayBadge } from "@website/accommodation-ui/hotel-snapp-pay";
import { useCompatRouter } from "@website/hooks/compat-router";
import { useViewPort } from "@website/hooks/viewport";
import { MaterialIcon } from "@website/icons/material";
import { MiniChips } from "@website/ui/mini-chips";
import { numberConvert } from "@website/utils/number-convert";
import { numberSeparator } from "@website/utils/number-separator";
import omit from "lodash-es/omit";
import { FC, MouseEvent } from "react";
export const HotelCardInfo: FC<HotelCardInfoPropertiesType> = properties => {
  const $ = _c(141);
  const router = useCompatRouter();
  const {
    hotelTitle,
    stars,
    rating,
    reviewCount,
    address,
    roomTitle,
    roomCount,
    regularBadges,
    advertisementBadge,
    size: t0,
    isFomo,
    snappPayData,
    loading,
    pricing,
    isSuggestedCard,
    facilities,
    id,
    showMap,
    location,
    propertyId,
    reservationInfo,
    isInstant,
    linkProperties,
    isAvailable,
    transportation,
    isHotelDomHomePage
  } = properties;
  const size = t0 === undefined ? "responsive" : t0;
  const {
    date_from,
    date_to
  } = router.query;
  const {
    isMobile
  } = useViewPort();
  const TitleComponent = size === "small" ? "span" : "h3";
  const appName = process.env.NEXT_PUBLIC_APP_NAME;
  const isVillaAllowed = appName === "villa" && size !== "small";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["hotel-domestic", "hotel-international", "tour"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const isHotel = t1.includes(appName ?? "");
  const isInternational = appName === "hotel-international" || properties.isInternational;
  const isHomePage = appName === "homepage" || appName === "website";
  const hasDate = Boolean(date_from && date_to);
  const hasPassenger = Boolean(reservationInfo?.bedCount) && Number(reservationInfo?.bedCount) > 0;
  let t2;
  if ($[1] !== id || $[2] !== router) {
    t2 = event => {
      event.stopPropagation();
      event.preventDefault();
      router.replace(router?.pathname, {
        ...router?.query,
        [HOTEL_DETAILS_ACTIVE_TAB]: "features",
        selectedHotelId: id
      }, {
        shallow: true,
        scroll: false
      });
    };
    $[1] = id;
    $[2] = router;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onHotelDetailClick = t2;
  const t3 = `flex min-w-0 shrink grow flex-col ${size === "xSmall" ? "" : size === "small" ? "gap-2" : "gap-3 pt-3 md:px-3 lg:pt-0"} `;
  const t4 = `flex flex-col ${size === "xSmall" ? "gap-0" : "gap-0.5"}`;
  let t5;
  if ($[4] !== advertisementBadge?.text) {
    t5 = advertisementBadge?.text && <MiniChips color="ads" size="small" text={advertisementBadge?.text} variant="contained" />;
    $[4] = advertisementBadge?.text;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = linkProperties as HotelCardLinkProperties;
  const t7 = `hotel-card-title text-on-surface-high-emphasis flex flex-row gap-1 truncate font-bold ${size === "xSmall" ? "text-xs" : size === "small" ? "text-subtitle-1" : ""}`;
  const t8 = isInternational ? "en" : router.locale || "fa";
  let t9;
  if ($[6] !== hotelTitle || $[7] !== t8) {
    t9 = numberConvert(hotelTitle, {
      locale: t8
    });
    $[6] = hotelTitle;
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== t9) {
    t10 = <span className="block min-w-0 truncate">{t9}</span>;
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== TitleComponent || $[12] !== t10 || $[13] !== t7) {
    t11 = <TitleComponent className={t7} data-testid="hotel_card_title" dir={appName === "hotel-international" ? "ltr" : "rtl"}>{t10}</TitleComponent>;
    $[11] = TitleComponent;
    $[12] = t10;
    $[13] = t7;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t11 || $[16] !== t6) {
    t12 = <HotelCardLink {...t6} className="min-w-0 flex-1 truncate">{t11}</HotelCardLink>;
    $[15] = t11;
    $[16] = t6;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t12 || $[19] !== t5) {
    t13 = <div className="flex flex-row items-center gap-1">{t5}{t12}</div>;
    $[18] = t12;
    $[19] = t5;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  const t14 = `${isSuggestedCard ? "mt-1 flex flex-col items-start justify-between" : "hidden"}`;
  let t15;
  if ($[21] !== size || $[22] !== stars) {
    t15 = <HotelCardStars size={size} starSize="small" stars={stars} />;
    $[21] = size;
    $[22] = stars;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== id || $[25] !== propertyId || $[26] !== rating || $[27] !== reviewCount || $[28] !== size) {
    t16 = size === "xSmall" && rating && Boolean(rating > 0) ? <HotelCardRating id={id} hasIcon={false} isSuggestedCard={false} propertyId={propertyId} rating={rating} reviewCount={reviewCount} size={size} /> : null;
    $[24] = id;
    $[25] = propertyId;
    $[26] = rating;
    $[27] = reviewCount;
    $[28] = size;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== size || $[31] !== stars) {
    t17 = stars === 0 && size === "xSmall" && <div className="!h-[14px]" />;
    $[30] = size;
    $[31] = stars;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== rating || $[34] !== size) {
    t18 = rating === 0 && size === "xSmall" && <div className="!h-[16px]" />;
    $[33] = rating;
    $[34] = size;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t14 || $[37] !== t15 || $[38] !== t16 || $[39] !== t17 || $[40] !== t18) {
    t19 = <div className={t14}>{t15}{t16}{t17}{t18}</div>;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
    $[39] = t17;
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t13 || $[43] !== t19 || $[44] !== t4) {
    t20 = <div className={t4}>{t13}{t19}</div>;
    $[42] = t13;
    $[43] = t19;
    $[44] = t4;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== router.pathname || $[47] !== size || $[48] !== stars) {
    t21 = router.pathname.includes("map") && <HotelCardStars size={size} starSize="large" stars={stars} />;
    $[46] = router.pathname;
    $[47] = size;
    $[48] = stars;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  const t22 = `md:gap-3 ${size === "small" ? `${appName === "villa" || isHomePage && !isHotelDomHomePage ? "!justify-start md:!gap-2" : "!justify-between"} pb-1 md:!gap-1` : ""} flex flex-row ${isMobile ? "!justify-between" : "justify-start"}`;
  let t23;
  if ($[50] !== id || $[51] !== isSuggestedCard || $[52] !== propertyId || $[53] !== rating || $[54] !== reviewCount || $[55] !== size) {
    t23 = size !== "xSmall" && !isSuggestedCard && <HotelCardRating hasIcon={false} id={id} propertyId={propertyId} rating={rating} reviewCount={reviewCount} size={size} />;
    $[50] = id;
    $[51] = isSuggestedCard;
    $[52] = propertyId;
    $[53] = rating;
    $[54] = reviewCount;
    $[55] = size;
    $[56] = t23;
  } else {
    t23 = $[56];
  }
  let t24;
  if ($[57] !== address || $[58] !== id || $[59] !== isHotelDomHomePage || $[60] !== isSuggestedCard || $[61] !== location?.lat || $[62] !== location?.lng || $[63] !== propertyId || $[64] !== rating || $[65] !== reviewCount || $[66] !== router || $[67] !== size || $[68] !== stars) {
    t24 = !isSuggestedCard && <div className="flex flex-row items-center justify-between">{size === "small" && (appName === "villa" || isHomePage) && !isHotelDomHomePage && address ? <div className={`${location?.lat && location?.lng && !router?.pathname?.includes("map") ? "text-secondary" : "text-on-surface-medium-emphasis"} text-caption flex flex-row items-center gap-1`}><MaterialIcon name="location_on" variant="outlined" /><span className={`max-w-[110px] truncate ${location?.lat && location?.lng && !router?.pathname?.includes("map") ? "cursor-pointer" : ""}`} onClick={location?.lat && location?.lng && !router?.pathname?.includes("map") ? event_0 => {
          event_0.stopPropagation();
          event_0.preventDefault();
          return router?.push(`${isHomePage ? "/villa" : ""}/map`, {
            ...omit(router?.query, ["cityTitle", "locationType", "extra_capacity", "modal"]),
            selectedHotelId: id,
            coordinate: `${location?.lat},${location?.lng},,15`
          });
        } : undefined}>{address}</span></div> : router.pathname.includes("map") ? null : <HotelCardStars size={size} starSize="large" stars={stars} />}{size === "xSmall" && <HotelCardRating id={id} propertyId={propertyId} rating={rating} reviewCount={reviewCount} size={size} />}</div>;
    $[57] = address;
    $[58] = id;
    $[59] = isHotelDomHomePage;
    $[60] = isSuggestedCard;
    $[61] = location?.lat;
    $[62] = location?.lng;
    $[63] = propertyId;
    $[64] = rating;
    $[65] = reviewCount;
    $[66] = router;
    $[67] = size;
    $[68] = stars;
    $[69] = t24;
  } else {
    t24 = $[69];
  }
  let t25;
  if ($[70] !== t22 || $[71] !== t23 || $[72] !== t24) {
    t25 = <div className={t22}>{t23}{t24}</div>;
    $[70] = t22;
    $[71] = t23;
    $[72] = t24;
    $[73] = t25;
  } else {
    t25 = $[73];
  }
  let t26;
  if ($[74] !== roomTitle || $[75] !== router.locale || $[76] !== size) {
    t26 = roomTitle && size === "small" && appName === "villa" && <div className={`${size === "small" ? "w-[200px]" : "w-[120px]"} text-on-surface-medium-emphasis flex items-center justify-start gap-1 md:w-[200px]`}>{size === "small" && <MaterialIcon name="person" />}<span className={`text-caption ${size === "small" ? "" : "truncate"}`} data-testid="hotel_card_room_title">{numberConvert(roomTitle, {
          numberOnly: false,
          locale: router.locale
        })}</span></div>;
    $[74] = roomTitle;
    $[75] = router.locale;
    $[76] = size;
    $[77] = t26;
  } else {
    t26 = $[77];
  }
  let t27;
  if ($[78] !== hasDate || $[79] !== hasPassenger || $[80] !== pricing?.basePriceOff || $[81] !== pricing?.price || $[82] !== router.locale || $[83] !== size) {
    t27 = appName === "villa" && hasDate && hasPassenger && pricing?.price && pricing?.basePriceOff && size === "small" ? <div className="text-on-surface-medium-emphasis flex items-center justify-start gap-1"><MaterialIcon name="payments" variant="outlined" /><div className="text-caption whitespace-nowrap pe-1">شروع قیمت از</div><div className="flex flex-col items-end gap-1"><div className="text-subtitle-2">{numberConvert(numberSeparator(pricing?.basePriceOff), {
            locale: router.locale || "fa"
          })}<span className="text-caption px-1">تومان</span></div></div></div> : null;
    $[78] = hasDate;
    $[79] = hasPassenger;
    $[80] = pricing?.basePriceOff;
    $[81] = pricing?.price;
    $[82] = router.locale;
    $[83] = size;
    $[84] = t27;
  } else {
    t27 = $[84];
  }
  let t28;
  if ($[85] !== transportation) {
    t28 = appName === "tour" && transportation ? <div className="flex flex-row items-center gap-1">{transportation.icons.map(_temp)}<div className="text-on-surface-high-emphasis text-sm">{transportation.text}</div></div> : null;
    $[85] = transportation;
    $[86] = t28;
  } else {
    t28 = $[86];
  }
  let t29;
  if ($[87] !== address || $[88] !== facilities || $[89] !== isFomo || $[90] !== isSuggestedCard || $[91] !== regularBadges || $[92] !== roomCount || $[93] !== roomTitle || $[94] !== size) {
    t29 = size !== "xSmall" && <HotelCardInfoOptions className={size === "small" ? "flex flex-col gap-2" : "flex flex-col gap-2 lg:gap-1"} address={address} facilities={facilities} isFomo={isFomo} isSuggestedCard={isSuggestedCard} regularBadges={regularBadges} roomCount={roomCount} roomTitle={roomTitle} size={size} />;
    $[87] = address;
    $[88] = facilities;
    $[89] = isFomo;
    $[90] = isSuggestedCard;
    $[91] = regularBadges;
    $[92] = roomCount;
    $[93] = roomTitle;
    $[94] = size;
    $[95] = t29;
  } else {
    t29 = $[95];
  }
  let t30;
  if ($[96] !== isAvailable || $[97] !== loading || $[98] !== pricing?.price || $[99] !== pricing?.priceOff || $[100] !== size || $[101] !== snappPayData) {
    t30 = size !== "small" && size !== "xSmall" && <div className="mt-auto hidden md:block">{isAvailable && <HotelSnappPayBadge {...snappPayData} loading={loading} page="cityPage" price={pricing?.priceOff || pricing?.price} />}</div>;
    $[96] = isAvailable;
    $[97] = loading;
    $[98] = pricing?.price;
    $[99] = pricing?.priceOff;
    $[100] = size;
    $[101] = snappPayData;
    $[102] = t30;
  } else {
    t30 = $[102];
  }
  const t31 = `${size === "small" && !isMobile ? "" : "mb-2"} flex flex-row items-center ${appName === "villa" || isHomePage ? "justify-start" : "justify-between"} gap-1`;
  let t32;
  if ($[103] !== address || $[104] !== id || $[105] !== isHotelDomHomePage || $[106] !== isInternational || $[107] !== isSuggestedCard || $[108] !== isVillaAllowed || $[109] !== location?.lat || $[110] !== location?.lng || $[111] !== router || $[112] !== showMap) {
    t32 = !router.pathname.includes("map") && !isSuggestedCard && (showMap || address) && (isVillaAllowed || isHotel || isHotelDomHomePage) ? <div className="flex min-w-0 items-center justify-start gap-1"><MaterialIcon className={`shrink-0 ${showMap ? "text-secondary" : "text-on-surface-high-emphasis"}`} name="location_on" variant="outlined" /><span className={`md:max-w-[255px] ${showMap ? "text-secondary cursor-pointer" : "text-on-surface-high-emphasis"} text-caption truncate`} dir={isInternational && appName !== "tour" ? "ltr" : ""} onClick={event_1 => {
        event_1.stopPropagation();
        event_1.preventDefault();
        if (!showMap) {
          return;
        }
        if (appName === "hotel-domestic" && location?.lat && location?.lng) {
          return router?.[router.pathname.includes("map") ? "replace" : "push"](`${isHomePage ? "/villa" : ""}/map`, {
            ...omit(router?.query, ["hotelTitle", "cityTitle", "locationType", "extra_capacity", "modal"]),
            selectedHotelId: id,
            coordinate: `${location?.lat},${location?.lng},11,33`
          });
        }
        return router.replace(router?.pathname, {
          ...router?.query,
          modal: "map",
          selectedHotelId: id
        }, {
          shallow: true,
          scroll: false
        });
      }}>{address ?? "\u0645\u0634\u0627\u0647\u062F\u0647 \u0631\u0648\u06CC \u0646\u0642\u0634\u0647"}</span></div> : <div />;
    $[103] = address;
    $[104] = id;
    $[105] = isHotelDomHomePage;
    $[106] = isInternational;
    $[107] = isSuggestedCard;
    $[108] = isVillaAllowed;
    $[109] = location?.lat;
    $[110] = location?.lng;
    $[111] = router;
    $[112] = showMap;
    $[113] = t32;
  } else {
    t32 = $[113];
  }
  let t33;
  if ($[114] !== onHotelDetailClick) {
    t33 = appName === "tour" ? <button className="text-secondary text-caption min-w-max cursor-pointer max-md:text-start" type="button" onClick={onHotelDetailClick}>جزییات هتل</button> : null;
    $[114] = onHotelDetailClick;
    $[115] = t33;
  } else {
    t33 = $[115];
  }
  const t34 = `flex flex-wrap justify-start gap-3 ${!isInstant && (!regularBadges?.length || appName !== "villa") ? "hidden" : ""} ${(process.env.NEXT_PUBLIC_APP_NAME === "villa" || isHomePage) && isMobile && "mb-2"}`;
  let t35;
  if ($[116] !== isInstant) {
    t35 = isInstant && <MiniChips StartIcon={<MaterialIcon name="bolt" />} className={`!bg-warning !text-on-surface-high-emphasis ${isInstant ? "" : "!hidden"}`} text={"\u0631\u0632\u0631\u0648 \u0622\u0646\u06CC"} variant="contained" />;
    $[116] = isInstant;
    $[117] = t35;
  } else {
    t35 = $[117];
  }
  let t36;
  if ($[118] !== regularBadges || $[119] !== router.locale) {
    t36 = process.env.NEXT_PUBLIC_APP_NAME === "villa" && Boolean(regularBadges?.length) && regularBadges?.map((badge, index) => <MiniChips key={`${badge.text}-${index}`} text={numberConvert(badge.text, {
      locale: router.locale || "fa"
    })} variant="accent" />);
    $[118] = regularBadges;
    $[119] = router.locale;
    $[120] = t36;
  } else {
    t36 = $[120];
  }
  let t37;
  if ($[121] !== t34 || $[122] !== t35 || $[123] !== t36) {
    t37 = <div className={t34}>{t35}{t36}</div>;
    $[121] = t34;
    $[122] = t35;
    $[123] = t36;
    $[124] = t37;
  } else {
    t37 = $[124];
  }
  let t38;
  if ($[125] !== t31 || $[126] !== t32 || $[127] !== t33 || $[128] !== t37) {
    t38 = <div className={t31}>{t32}{t33}{t37}</div>;
    $[125] = t31;
    $[126] = t32;
    $[127] = t33;
    $[128] = t37;
    $[129] = t38;
  } else {
    t38 = $[129];
  }
  let t39;
  if ($[130] !== t20 || $[131] !== t21 || $[132] !== t25 || $[133] !== t26 || $[134] !== t27 || $[135] !== t28 || $[136] !== t29 || $[137] !== t3 || $[138] !== t30 || $[139] !== t38) {
    t39 = <div className={t3}>{t20}{t21}{t25}{t26}{t27}{t28}{t29}{t30}{t38}</div>;
    $[130] = t20;
    $[131] = t21;
    $[132] = t25;
    $[133] = t26;
    $[134] = t27;
    $[135] = t28;
    $[136] = t29;
    $[137] = t3;
    $[138] = t30;
    $[139] = t38;
    $[140] = t39;
  } else {
    t39 = $[140];
  }
  return t39;
};
function _temp(icon) {
  return <MaterialIcon key={`icon-${icon}`} className={`text-xl ${icon === "flight" ? "rotate-45" : ""}`} name={icon} />;
}